(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["islahola-card-colours"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('islahola-card-colours')) {
    customElements.define('islahola-card-colours', class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.selectColour.bind(this));
        this.addEventListener('keydown', (event) => {
          if (event.key === ' ' && event.target.closest('[data-colour-name]')) {
            event.preventDefault();
            event.target.closest('[data-colour-name]').click();
          }
        });
      }

      connectedCallback() {
        this.mediaById = new Map();
        this.closest('product-info[data-layout="card"]')?.querySelectorAll('.card__media .product__media-item').forEach((media) => {
          const id = media.dataset.mediaId?.split('-').pop();
          if (id) this.mediaById.set(id, media.innerHTML);
        });
        this.querySelectorAll('[data-colour-name]').forEach((swatch) => {
          swatch.setAttribute('role', 'button');
          swatch.setAttribute('aria-pressed', String(swatch.classList.contains('is-selected')));
        });
      }

      selectColour(event) {
        const swatch = event.target.closest('[data-colour-name]');
        if (!swatch || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const card = this.closest('product-info[data-layout="card"]');
        if (!card) return;
        const media = card.querySelector('.card__media .product__media-item');
        const mediaHtml = this.mediaById?.get(swatch.dataset.mediaId);
        if (media && !mediaHtml) return;
        event.preventDefault();

        if (media && mediaHtml) {
          media.innerHTML = mediaHtml;
          media.querySelectorAll('a.media img:not(:first-child)').forEach((image) => image.remove());
          const idParts = media.dataset.mediaId.split('-');
          idParts[idParts.length - 1] = swatch.dataset.mediaId;
          media.dataset.mediaId = idParts.join('-');
        }
        card.querySelectorAll('[data-islahola-selected-colour]').forEach((label) => {
          label.textContent = swatch.dataset.colourName;
        });
        this.querySelectorAll('[data-colour-name]').forEach((item) => {
          const selected = item === swatch;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        card.querySelectorAll('.card__heading a, .card__media a, a.add-to-cart__submit').forEach((link) => {
          link.href = swatch.href;
        });
        card.querySelectorAll('.quick-add__submit[data-product-url]').forEach((button) => {
          button.dataset.productUrl = swatch.href;
        });
        card.querySelectorAll('product-form input[name="id"]').forEach((input) => {
          if (!input.closest('quick-add-modal')) input.value = swatch.dataset.variantId;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
